<template>
  <!-- Figma: row p-8 gap-8、サムネ 72x72、タイトル p1 17/24 (1 行・ellipsis)、
       meta は p2 16/24 と p3 14/20 のベースライン揃え、区切りは "|" 12/16 fg.muted -->
  <NuxtLink class="flex items-center gap-2 rounded-[2px] p-2 hover:bg-black/5" :to="location" @click="props.onClick">
    <OptimizedImage
      loading="lazy"
      :alt="hit.experience.name"
      :class="['size-[72px] shrink-0 rounded-[2px] object-cover']"
      :image-url="hit.experience.thumbnailUrl"
      :optimized-image-options="{ width: 240 }"
    />
    <div class="flex flex-1 flex-col justify-center overflow-hidden font-Spectral">
      <p class="truncate text-[17px] leading-6 text-gray4">{{ hit.experience.name }}</p>
      <p class="flex flex-wrap items-center gap-x-1 text-gray4">
        <span class="text-[16px] leading-6">{{ hit.experience.location }}</span>
        <span aria-hidden="true" class="text-[12px] leading-4">|</span>
        <span class="flex items-baseline">
          <img alt="" class="size-4 shrink-0 self-center" src="@/assets/icon/wabunka/schedule.svg" />
          <span class="text-[16px] leading-6">{{ hit.experience.durationMinutes }}</span>
          <span class="text-[14px] leading-5">min</span>
        </span>
        <span aria-hidden="true" class="text-[12px] leading-4">|</span>
        <span class="flex items-baseline">
          <span class="text-[14px] leading-5">from {{ priceSymbol }}</span>
          <span class="text-[16px] leading-6">{{ formattedPrice }}</span>
          <span class="text-[14px] leading-5">/person</span>
        </span>
      </p>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { OptimizedImage } from '@/wabunka-src/common/components';
import { CURRENCY_SYMBOLS } from '@/wabunka-src/common/utils/currency';
import type { ConvertedPrice } from '@/wabunka-src/features/Search/composables/query/useConvertedExperiencePricesQuery';
import type { AlgoliaExperienceHit } from '@/wabunka-src/features/Search/models/algoliaHit';
import { buildExperienceLocation } from '@/wabunka-src/features/Search/models/algoliaHitLink';

interface Props {
  hit: AlgoliaExperienceHit;
  onClick?: () => void;
  // 表示通貨が JPY 以外のとき、SearchResults から渡される。未指定なら JPY 表示。
  convertedPrice?: ConvertedPrice;
}

const props = defineProps<Props>();

const location = computed(() => buildExperienceLocation(props.hit));

// 換算価格がある間はそちらを優先表示。fetch 中は前回値 / JPY のままなので素直に切り替わる
const priceSymbol = computed(() => {
  if (props.convertedPrice) return CURRENCY_SYMBOLS[props.convertedPrice.currency] ?? '';
  return '¥';
});
const formattedPrice = computed(() => {
  const amount = props.convertedPrice ? Math.round(props.convertedPrice.amount) : props.hit.experience.price;
  return amount.toLocaleString('en-US');
});
</script>
